import { useTranslate } from 'core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import FiltersDynamicAside from '../../components/asides/FiltersDynamicAside/FiltersDynamicAside';
import Icon from '../Icon';
import InputText from './../InputText';
import useInputSearch from './useInputSearch';

const InputSearch = ({ iconLeft, placeholder, onChange, value, recentSearches, onClickRemoveSearch, filters, onApplyFilters, onChangeFilters }) => {
  const { t } = useTranslate();
  const inputRef = useRef();
  const { inputVal, showRecentSearches, handleChange, onShowRecentSearches, onHideRecentSearches, onRepeatSearch } = useInputSearch({
    onChange,
    value,
    recentSearches,
    inputRef,
  });
  const [isFiltersOpen, setIsFiltersOpen] = React.useState(false);

  function handleOpenFilters() {
    setIsFiltersOpen(true);
  }
  function handleCloseFilters() {
    setIsFiltersOpen(false);
  }
  function handleApplyFilters(selected) {
    if (onApplyFilters) onApplyFilters(selected);
    setIsFiltersOpen(false);
  }

  return (
    <div className="input-search" ref={inputRef}>
      {Array.isArray(filters) && filters.length > 0 && (
        <div className="input-search__filters" onClick={handleOpenFilters} style={{ cursor: 'pointer' }}>
          <Icon type="filters" /> <div className="input-search__filters-text"> {t('common:Filter')} </div>
        </div>
      )}
      <InputText
        icon="search"
        placeholder={placeholder}
        onChange={handleChange}
        value={inputVal}
        iconLeft={iconLeft}
        onClick={onShowRecentSearches}
        onKeyPress={(e) => {
          if (e.key === 'Enter') onHideRecentSearches();
        }}
      />
      {showRecentSearches && (
        <div className="input-search__recent-container">
          <div className="input-search__recent-title"> {t('common:Recent searches')} </div>
          {recentSearches.length > 0 ? (
            recentSearches.slice(0, 6).map((item, index) => (
              <div key={index} className="input-search__recent-item">
                <div className="input-search__recent-item-left" onClick={() => onRepeatSearch(item)}>
                  <Icon type={'search'} /> <div className="input-search__recent-item-text"> {item} </div>
                </div>
                <div
                  className="input-search__recent-item-right"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClickRemoveSearch(item);
                  }}
                >
                  <Icon type={'close'} />
                </div>
              </div>
            ))
          ) : (
            <div className="input-search__recent--no-items"> {t('common:No recent searches')} </div>
          )}
        </div>
      )}
      {Array.isArray(filters) && filters.length > 0 && (
        <FiltersDynamicAside
          open={isFiltersOpen}
          onClose={handleCloseFilters}
          filters={filters}
          onApplyFilters={handleApplyFilters}
          onChangeFilters={onChangeFilters}
        />
      )}
    </div>
  );
};

InputSearch.defaultProps = {
  iconLeft: false,
  placeholder: 'Buscar',
  recentSearches: [],
  filters: [],
  onApplyFilters: undefined,
  onChangeFilters: undefined,
};

InputSearch.propTypes = {
  iconLeft: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  recentSearches: PropTypes.array,
  onClickRemoveSearch: PropTypes.func,
  filters: PropTypes.array,
  onApplyFilters: PropTypes.func,
  onChangeFilters: PropTypes.func,
};

export default InputSearch;
